<template>
  <div class="index_regist">
    <div class="anlan-logo">
      <img src="/static/imgs/anlan-logo.png"/>
    </div>
    <div class="regist_form">
      <el-row style="margin-bottom:3vh;">
        <el-col :span="24">
          <h2 style="color:white;font-size:1.8rem;letter-spacing:.1rem;">安蓝航运智能助手</h2>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-input suffix-icon="el-icon-phone" v-model="phone"><template slot="prepend">手机号码</template></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-input placeholder="请输入验证码" v-model="vercode" show-password><template slot="prepend">验 证 码</template></el-input>
        </el-col>
        <el-col :span="6">
          <el-button :type="phoneValid ? 'none' : 'info'" icon="el-icon-message" circle @click="sendVercode"></el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-input placeholder="请输入密码" v-model="password" show-password><template slot="prepend">登陆密码</template></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-input placeholder="再次输入密码" v-model="repassword" show-password><template slot="prepend">重复密码</template></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-button type="danger" @click="regist">提 交 注 册</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="login">返 回 登 陆</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { websendphonevalid,webphoneregist } from '../../api/api'
  import ElRow from "element-ui/packages/row/src/row";
  import { setJsonStorage } from "../../util/storage";

  export default {
    components: {ElRow},
    name: "IndexRegist",
    data() {
      return {
        phone:"",
        vercode:"",
        password:"",
        repassword:"",
        phoneValid:false
      }
    },
    methods: {
      regist(){
        if(this.phone == null || this.phone === "" || this.phone.length < 6){
          this.$message.error({showClose:true,duration:3000,message:'请输入正确的手机号'});
        }else if(this.vercode == null || this.vercode === ""){
          this.$message.error({showClose:true,duration:3000,message:'验证码不能为空'});
        }else if(this.password==null || this.password === "" || this.password.length < 6){
          this.$message.error({showClose:true,duration:3000,message:'密码至少6位字母和数字'});
        }else if(this.password !== this.repassword){
          this.$message.error({showClose:true,duration:3000,message:'两次输入密码不一致'});
        }else{
          webphoneregist({phone:this.phone,vercode:this.vercode,password:this.password,repassword:this.repassword,username:'w'+this.phone}).then(res => {
            if(res && res.status === 0){
              this.$router.push("/index/login");
            }
          })
        }
      },
      sendVercode(){
        if(!this.phoneValid){
          this.$message.error({showClose:true,duration:3000,message:'请输入正确的手机号'});
        }else{
          websendphonevalid(this.phone).then(res => {
            if(res && res.status === 0){
              this.$message.success({showClose:true,duration:1000,message:'验证码发送成功'});
            }else{
              this.$message.error({showClose:true,duration:3000,message:res.message});
            }
          })
        }
      },
      login(){
        this.$router.push("/index/login");
      }
    },
    watch:{
      phone(val,oval){
        this.phoneValid = val.match(/1[3-9][0-9]{9}/ig);
      }
    }
  }
</script>

<style scoped>
  .index_regist {
    position: absolute;
    top:0;
    left:0;
    padding:0;
    margin:0;
    height: 100vh;
    background: #3AA7C2;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-image:url('http://static.anlantech.cn/static/png/background.png');
    overflow:hidden;
    z-index:199;
  }
  .anlan-logo {
    position: absolute;
    top:5vh;
    left:10%;
    width:90%;
    height:20vh;
  }
  .anlan-logo img {
    width:9rem;
  }
  .regist_form {
    position: absolute;
    top:20vh;
    width:80%;
    margin: 0 10%;
    padding:0;
    text-align:center;
  }
  .el-col {
    height:6vh;
    line-height:6vh;
    margin-bottom:3vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/regist.vue